import React from 'react';
import { SearchIcon } from './icons';

const SearchInput = ({ value, onChange, placeholder = 'Search...', className = '' }) => (
    <div className={`relative ${className}`}>
        <span className="absolute inset-y-0 left-3 flex items-center text-[#9CA3AF] pointer-events-none">
            <SearchIcon className="h-4 w-4" />
        </span>
        <input
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className="w-full rounded-xl border border-[#E5E7EB] bg-white pl-9 pr-3 py-2.5 text-sm text-[#1F2937] placeholder-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#7C5CFC] focus:border-transparent"
        />
    </div>
);

export default SearchInput;
